<div>
    <app-entity-meta *ngFor="let span of spans$ | async; trackBy:identify" [span]="span"></app-entity-meta>
</div>
